export default "__VITE_PUBLIC_ASSET__c76b2f27__"